// extracted by mini-css-extract-plugin
export default {"input":"Input-module__input--x4NbF"};